
import React, { useCallback } from 'react';
import { IProps } from './types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import style from './style.module.scss';
import classNames from 'classnames';

const NS = 'SimpleDialog';

export default function SimpleDialog({
  dataTestId,
  isOpen = false,
  confirmText,
  rejectText,
  title,
  description,
  children,
  handleConfirm,
  handleReject,
  diffInfoList,
  dialogSize
}: IProps) {

  return (
    <Dialog
      maxWidth={dialogSize}
      data-testid={dataTestId}
      open={isOpen}
      onClose={handleReject}
      aria-labelledby="simple-dialog-title"
      aria-describedby="simple-dialog-description">
      <DialogTitle id="simple-dialog-title" disableTypography={true} className={style.dialogBox}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="simple-dialog-description" className={style.description}>
          <span dangerouslySetInnerHTML={{__html:description}} />
        </DialogContentText>
        {
          diffInfoList && (
            <table className={classNames({
              [style.fullWidth]: true,
              [style.removeBorder]: true,
              })}>
              {diffInfoList.map((info, index) => {
                return(
                  <tr key={index}>
                    <td>{info.label || info.key}:</td>
                    <td>{info.original}</td>
                    <td>
                      <span><ArrowRightAltIcon /></span>
                    </td>
                    <td>{info.new}</td>
                  </tr>
                )
              })}
            </table>
          )
        }
      </DialogContent>
      {children}
      <DialogActions>
        <Button onClick={() => {
          handleReject();
        }} color="default">
          {rejectText}
        </Button>
        <Button
          onClick={() => handleConfirm()}
          color="primary"
          autoFocus
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

